module.exports = ".qr-main-bg {\r\n\tbackground-color: #af2926 !important\r\n}\r\n.qr-btn-bg-main:hover, .qr-btn-bg-main:active{\r\n\tbackground-color: #af2926\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/invoice-item-record-component/invoice-item-record.component.css
// module id = ./src/QrMena/components/invoice-item-record-component/invoice-item-record.component.css
// module chunks = main